import { TESTIMONIAL_FIELDS } from '$graphql/queries/testimonials';
import { gql } from '$lib/apollo';

const REVIEW_FIELDS = gql`
  fragment ReviewFields on API_Testimonial {
    ...TestimonialFields
    featuredPosition
    product {
      id
      name
      productType
    }
  }
  ${TESTIMONIAL_FIELDS}
`;

const GAME_FIELDS = gql`
  fragment GameFields on API_Game {
    id
    slug
    logoMain {
      original {
        url
      }
    }
    localizedTitles {
      en
    }
  }
`;

const ACCOUNT_FIELDS = gql`
  fragment AccountFields on API_Account {
    id
    name
    slug
    avatar {
      original {
        url
      }
    }
  }
`;

const PRODUCT_FIELDS = gql`
  fragment ProductFields on API_Product {
    id
    name
    description
    slug
    productType
    hasLeftTestimonial
    cover {
      original {
        url
      }
    }
    account {
      ...AccountFields
    }
    pricingOptions {
      id
      price
    }
  }
  ${ACCOUNT_FIELDS}
`;

const COACHING_FIELDS = gql`
  fragment CoachingFields on API_ProductCoaching {
    id
    durationSeconds
    product {
      ...ProductFields
    }
    game {
      ...GameFields
    }
    sessionConnection {
      totalCount
    }
  }
  ${GAME_FIELDS}
  ${PRODUCT_FIELDS}
`;

const EVENT_FIELDS = gql`
  fragment EventFields on API_ProductEvent {
    id
    durationSeconds
    product {
      ...ProductFields
    }
    game {
      ...GameFields
    }
  }
  ${GAME_FIELDS}
  ${PRODUCT_FIELDS}
`;

const GUIDE_FIELDS = gql`
  fragment GuideFields on API_ProductGuide {
    id
    product {
      ...ProductFields
    }
    game {
      ...GameFields
    }
  }
  ${GAME_FIELDS}
  ${PRODUCT_FIELDS}
`;

export const REVIEW_PRODUCT_FIELDS = gql`
  fragment ReviewProductFields on API_Product {
    ...ProductFields
    productType
    coaching {
      ...CoachingFields
    }
    event {
      ...EventFields
    }
    guide {
      ...GuideFields
    }
  }
  ${PRODUCT_FIELDS}
  ${COACHING_FIELDS}
  ${EVENT_FIELDS}
  ${GUIDE_FIELDS}
`;

export const POST_REVIEW = gql`
  mutation TestimonialCreate($input: TestimonialCreateInput!) {
    testimonialCreate(input: $input) {
      result {
        ...ReviewFields
      }
      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${REVIEW_FIELDS}
`;

export const GET_REVIEW_PRODUCT_INFO = gql`
  query GetReviewProductInfo($productId: UUID!) {
    product(id: $productId) {
      ...ReviewProductFields
    }
  }
  ${REVIEW_PRODUCT_FIELDS}
`;
